import { gql } from "@apollo/client";

// `search_people` matches on email as well as on first/last name, so it serves
// both the exact email lookup and the name autocomplete.
export const SearchPeople = gql`
  query NE_SearchPeople($text: String!, $limit: Int) {
    result: search_people(text: $text, limit: $limit) {
      people {
        id
        person_id
        transactor_id
        first_name
        last_name
        email
        avatar_uri
        location {
          id
          village
          district
          subdistrict
          province
        }
      }
      total
    }
}
`
